import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  TemplateRef,
} from '@angular/core';
import { NzMessageService } from 'ng-zorro-antd';
import { Observable, Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { ADSTColumn, ADSTColumnBtn, ADSTColumnGroup, ADSTData, ADSTReqParams, ADSTReqReName, ADSTResReName } from './ad-st.interface';
import { HttpService, HttpRequestType } from '@ang-kit/http';
import { ADSTConfig } from './ad-st.config';
// TODO æ°åè½ 1.å¯ä»¥ç¦ç¨æäºcheckbox(å­å¨é®é¢å¨éé®é¢)
@Component({
  selector: 'ad-st',
  templateUrl: './ad-st.component.html',
  providers: [HttpService],
  styleUrls: ['./ad-st.component.less']
})
export class ADSTComponent implements OnInit, OnChanges {
  /**
   * æ¯å¦åå§åå®æ
   */
  private initComplete = false;
  /**
   * é¡µé¢ååæ°æ®æµ
   */
  private pageChanges$ = new Subject();

  /**
   * è¡¨æ ¼çæ­£çæ°æ®æº
   */
  _data: ADSTData[] = [];
  /**
   * æ¯å¦æ¾ç¤ºå è½½å¨ç»
   */
  loading = false;
  /**
   * å½åé¡µç 
   */
  pageIndex = 1;
  /**
   * æ¯é¡µæ°é
   */
  @Input()
  pageSize = 10;
  /**
   * å½åéä¸­çæ°æ®ï¼å¤é¨ç´æ¥è·åï¼ä¸è½ä¿®æ¹ï¼åªè½è¯»å
   */
  checkedData: ADSTData[] = [];
  /**
   * æ¯å¦å¾éäºå¨é¨
   */
  allChecked = false;
  /**
   * æ¯å¦æéä¸­ï¼ä½ä¸æ¯å¨é
   */
  indeterminate = false;
  /**
   * è¡¨å¤´tr
   */
  headTrs: [ADSTColumn[]] = [[]];
  /**
   * æå¤§è·¨è¡æ°
   */
  maxRowSpan: number = null;

  /**
   * æ°æ®æº
   */
  @Input()
  data: string | ADSTData[] | Observable<ADSTData[]> = [];
  /**
   * æ°æ®æºç´¢å¼
   */
  @Input()
  dataKey = 'id';
  /**
   * è¯·æ±æ¹å¼
   */
  @Input()
  reqMethod: 'GET' | 'POST' | 'DELETE' | 'PUT' = 'POST';
  /**
   * è¯·æ±å¤´
   */
  @Input()
  reqHeader: any = null;

  /**
   * åå§åçæ¶åæ¯å¦å è½½æ°æ®
   */
  @Input()
  initLoadData = true;

  /**
   * é¢å¤åæ°
   */
  @Input()
  extraParams: any = null;
  /**
   * éå½åè¯·æ±åæ°
   */
  @Input()
  reqReName: ADSTReqReName = {
    page: {
      pageNo: 'pageNo',
      pageSize: 'pageSize'
    },
    sortKey: {
      sortName: 'sortName',
      sortValue: 'sortValue'
    },
    sortValue: {
      ascend: 'ascend',
      descend: 'descend'
    },
    sortWrapKey: 'sort',
    filterWrapKey: 'filter'
  };
  // éå½åè¿ååæ°ï¼æ¯æéå½åtotalãlistä¸¤ä¸ªåæ°
  @Input()
  resReName: ADSTResReName = {
    list: 'list',
    total: 'total'
  };

  /**
   * åæè¿°
   */
  @Input()
  columns: ADSTColumn[] = [];

  /**
   * å¤´é¨
   */
  @Input()
  header: string | TemplateRef<void>;
  /**
   * å°¾é¨
   */
  @Input()
  footer: string | TemplateRef<void>;
  /**
   * æ æ°æ®æ¶æ¾ç¤ºåå®¹
   */
  @Input()
  noResult: string | TemplateRef<void>;
  /**
   * tableå¤§å°
   */
  @Input()
  size: 'small' | 'middle' | 'default' = 'middle';
  /**
   * å»¶è¿æ¾ç¤ºå è½½ææçæ¶é´ï¼é²æ­¢éªçï¼
   */
  @Input()
  loadingDelay = 0;
  /**
   * æ¯å¦å±ç¤ºè¾¹æ¡
   */
  @Input()
  showBordered = true;
  /**
   * æ¨ªåæçºµåæ»å¨
   */
  @Input()
  scroll: { y?: string; x?: string };

  /**
   * æ¾ç¤ºä¸ºç®ååé¡µ
   */
  @Input()
  simple = false;
  /**
   * åªæä¸é¡µæ¶æ¯å¦éèåé¡µå¨
   */
  @Input()
  hideOnSinglePage = false;
  /**
   * æ¯å¦å¯ä»¥å¿«éè·³è½¬è³æé¡µ
   */
  @Input()
  showQuickJumper = true;
  /**
   * æ¯å¦å¯ä»¥æ¹åæ¯é¡µå¤§å°
   */
  @Input()
  showSizeChanger = true;
  /**
   * æ¯å¦æ¾ç¤ºåé¡µ
   */
  @Input()
  showPagination = true;
  /**
   * æ¯å¦åç«¯åé¡µ
   */
  @Input()
  isFrontPagination = false;
  /**
   * æ»æ°
   */
  @Input()
  total = 0;

  /**
   * å½ååæ¯å¦åå«å±å¼æé®
   */
  @Input()
  expand: TemplateRef<{ $implicit: any; }>;

  /**
   * æ¯å¦æ¾ç¤ºåºå·
   */
  @Input()
  showNumber = false;

  /**
   * æ¯å¦æ¾ç¤ºå¾éæ¡
   */
  @Input()
  showCheckBox = false;
  /**
   * æå¤§checkedæ°é
   */
  @Input()
  maxCheckedCount = 500;

  /**
   * æ¯å¦æ¾ç¤ºradio
   */
  @Input()
  showRadio = false;

  /**
   * æ¯å¦ååæåº
   */
  @Input()
  isSingleSort = false;

  /**
   * æ¯å¦æ¯å¼æ­¥æ å½¢ç±»åæ°æ®
   */
  @Input()
  asyncTreeData = false;

  /**
   * æ°æ®å¤çååè°
   */
  @Input()
  preDataChange: (data: ADSTData[]) => ADSTData[];
  /**
   * å¦æéè¦ä»å¤é¨æ¹åæ°æ®çæ¶åè°ç¨
   */
  @Input()
  preResponseDataChange: (data: any) => any;

  /**
   * è¯·æ±æ°æ®çåè°ï¼ä¼ åºè¯·æ±åæ°
   */
  @Output()
  requestDataEmitter = new EventEmitter<ADSTReqParams>();

  /**
   * è¯·æ±å­æ°æ®çåè°ï¼ä¼ åºè¯·æ±åæ°
   */
  @Output()
  requestChildrenDataEmitter = new EventEmitter<[ADSTData, ADSTReqParams]>();

  constructor(
    private msgService: NzMessageService,
    private cdr: ChangeDetectorRef,
    private httpService: HttpService,
    private config: ADSTConfig,
  ) {
    // åå¹¶éç½®
    const totalConfig = {...this.config};
    this.dataKey = totalConfig.dataKey;
    this.reqMethod = totalConfig.reqMethod;
    this.reqReName = totalConfig.reqReName;
    this.resReName = totalConfig.resReName;
    this.size = totalConfig.size;
    this.showBordered = totalConfig.showBordered;
    this.showNumber = totalConfig.showNumber;
    this.maxCheckedCount = totalConfig.maxCheckedCount;
  }

  ngOnInit() {
    // éæ°åå¹¶å¼
    this.reqReName = {...this.config.reqReName, ...this.reqReName};
    this.reqReName.page = {...this.config.reqReName.page, ...this.reqReName.page};
    this.reqReName.sortKey = {...this.config.reqReName.sortKey, ...this.reqReName.sortKey};
    this.reqReName.sortValue = {...this.config.reqReName.sortValue, ...this.reqReName.sortValue};
    this.resReName = {...this.config.resReName, ...this.resReName};

    // åå§åå®æ
    this.initComplete = true;

    // å¤ç columns
    this.columns.forEach(column => {
      // åå§åå¼
      column.formatFromCache = true;
      column.formatCache = {};
      column.titleFormatCache = null;

      // è®¾ç½® column æ ·å¼ å class
      this.setColumnOrGroupStylesAndClass(column);

      // è®¾ç½®æå¤§ rowSpan
      if (column.rowSpan) {
        if (!this.maxRowSpan) {
          this.maxRowSpan = column.rowSpan;
        }
        if (column.rowSpan > this.maxRowSpan) {
          this.maxRowSpan = column.rowSpan;
        }
      }

      // å¤çåç»æ°æ®
      if (!column.group) {
        this.headTrs[0].push(column);
      } else {
        // å push group
        if (!this.headTrs[column.group.level]) {
          this.headTrs[column.group.level] = [];
        }
        // é²æ­¢ group å push ä¸é
        const added = this.headTrs[column.group.level].some(item => {
          return item['title'] === column.group.title;
        });
        if (!added) {
          const group = column.group;
          this.setColumnOrGroupStylesAndClass(group);
          this.headTrs[column.group.level].push(group);
        }

        // å push column
        if (!this.headTrs[column.group.level + 1]) {
          this.headTrs[column.group.level + 1] = [];
        }
        this.headTrs[column.group.level + 1].push(column);
      }
    });

    // é²æå¨
    this.pageChanges$.pipe(
      debounceTime(200)
    ).subscribe(() => {
      this.loadData();
    });

    // ç©ºæ°æ®å¹¶ä¸éè¦åå§åæ°æ®å°±å è½½æ°æ®
    if (this.initLoadData) {
      this.loadData();
    }
  }

  ngOnChanges(changes) {
    // åæ°åå¨-è¯·æ±æ°æ®
    if (changes.extraParams) {
      if (this.initComplete) {
        // å½æåé¡µçæ¶åè¿åç¬¬ä¸é¡µ
        if (this.showPagination) {
          this.pageIndex = 1;
        }
        this.loadData();
      }
    }

    if (changes.columns && changes.columns.currentValue) {
      if (this.initComplete) {
        this.resetColumnsCache();
      }
    }

    // æ°æ®æºåå¨-å¤çæ°æ®
    if (changes.data && changes.data.currentValue) {
      // åæ­¢å è½½
      this.loading = false;

      // è·åå½åæ°æ®æºçå¼
      const currentValue = changes.data.currentValue;

      // æ°æ®æºåå
      if (currentValue instanceof Array) {
        this.resetColumnsCache();
        this.processData(currentValue);
      }
    }
  }

  /**
   * è®¾ç½® column æè Group ç æ ·å¼ å class
   */
  private setColumnOrGroupStylesAndClass(item: ADSTColumn | ADSTColumnGroup) {
    const totalConfig = this.config;
    if (!item.thClassName) {
      item.thClassName = totalConfig.thClassName;
    }
    if (!item.thStyles) {
      item.thStyles = totalConfig.thStyles;
    }
    if (!item.tdClassName) {
      item.tdClassName = totalConfig.tdClassName;
    }
    if (!item.tdStyles) {
      item.tdStyles = totalConfig.tdStyles;
    }
  }

  /**
   * éç½®è¡¨æ ¼çç¼å­
   */
  private resetColumnsCache() {
    this.columns.forEach(column => {
      // åå§åå¼
      column.formatCache = {};
      column.titleFormatCache = null;
    });
  }

  /**
   * å å·¥æ°æ®
   */
  private processData(data: ADSTData[]) {
    const treeData = this.convertTreeToArray(data);

    this.processCheckedData(treeData);
    this.processTreeData(data, null);

    // è®¾ç½®æ°æ®æº
    this._data = [...data];
    if (this.showPagination && this.isFrontPagination) {// åªæåç«¯åé¡µçæ¶åï¼ææå¨å¤ç
      this.total = data.length;
    }
  }

  /**
   * å¤çéä¸­æ°æ®
   */
  private processCheckedData(data: ADSTData[]) {
    if (this.showCheckBox) {
      data.forEach((item) => {
        // æ¯å¦æ¾å¨éä¸­çæ°æ®éé¢
        let findInChecked = false;
        this.checkedData.forEach((selectedData) => {
          if (this.dataKey) {
            if (item[this.dataKey] === selectedData[this.dataKey]) {
              findInChecked = true;
              item.checked = true;
            }
          }
        });

        // å¦ææ²¡ææ¾å°å¹¶ä¸æ¯éä¸­ç¶æï¼åæ·»å å°éä¸­æ°æ®éé¢
        if (!findInChecked && item.checked) {
          this.checkedData.push(item);
        }

        // å¦æé½æ²¡æï¼è®¾ç½®ä¸ºfalse
        if (!item.checked) {
          item.checked = false;
        }
      });

      const allChecked = data.every(value => value.checked === true);
      const allUnChecked = data.every(value => !value.checked);
      this.allChecked = allChecked;
      this.indeterminate = (!allChecked) && (!allUnChecked);
    }
  }

  /**
   * å¤çæ å½¢æ°æ®
   */
  private processTreeData(data: ADSTData[], parent: ADSTData, level: number = 0) {
    data.forEach(v => {
      v.parent = parent;
      v.level = level;
      v.isLoading = false;

      if (v.children && v.children.length > 0) {
        this.processTreeData(v.children, v, level + 1);
      }
    });
  }

  /**
   * æ å½¢ç»æå­æ°æ®å è½½å®æ
   */
  public treeChildrenDataLoadComplete() {
    this.processTreeData(this._data, null);
  }

  /**
   * å½åé¡µç æ¹åæ¶çåè°å½æ°
   */
  pageIndexChange(pageIndex: number) {
    if (this.pageIndex === 0) {
      return;
    }

    // åç«¯åé¡µï¼è¯·æ±æ°æ®
    if (!this.isFrontPagination) {
      this.pageChanges$.next();
    }
  }

  /**
   * é¡µæ°æ¹åæ¶çåè°å½æ°
   */
  pageSizeChange(pageSize: number) {
    this.pageIndex = 1;

    // åç«¯åé¡µï¼è¯·æ±æ°æ®
    if (!this.isFrontPagination) {
      this.pageChanges$.next();
    }
  }

  /**
   * è·åæ·±å±æ°æ®
   */
  private deepGet(obj, path = '') {
    if (!path) {
      return null;
    }
    // å°å­ç¬¦ä¸²è½¬æ¢ææ°ç»
    const arrayPath = path.split('.');

    let tempObj = obj;

    for (let i = 0; i < arrayPath.length; i++) {
      const pathStr = arrayPath[i];
      if (tempObj.hasOwnProperty(pathStr)) {
        tempObj = tempObj[pathStr];
      } else {
        return null;
      }
    }

    return tempObj;
  }

  /**
   * çæå¬å±åæ°
   */
  private generateCommonParams(): ADSTReqParams {
    // çæææè¯·æ±åæ°
    const totalParams: ADSTReqParams = {
      extra: null,
      page: null,
      sort: null,
      filter: null,
      merge: null
    };

    // åå¹¶é¢å¤åæ°
    if (this.extraParams !== null) {
      totalParams.extra = {...this.extraParams};
    }

    // åé¡µåæ°
    if (this.showPagination && !this.isFrontPagination) {
      if (!totalParams.page) {
        totalParams.page = {};
      }
      totalParams.page[this.reqReName.page.pageNo] = this.pageIndex;
      totalParams.page[this.reqReName.page.pageSize] = this.pageSize;
    }

    // (æåº && è¿æ»¤) åæ°
    this.columns.forEach((column: ADSTColumn) => {
      // æåº
      if (column.sort && column.sort.sortValue !== undefined && column.sort.sortValue !== null) {
        if (!totalParams.sort) {
          totalParams.sort = [];
        }

        const sort = {};

        // key
        sort[this.reqReName.sortKey.sortName] = column.index;

        // value
        let tureValue: any = column.sort.sortValue;
        if (tureValue === 'descend') {
          tureValue = this.reqReName.sortValue.descend;
        } else if (tureValue === 'ascend') {
          tureValue = this.reqReName.sortValue.ascend;
        }
        sort[this.reqReName.sortKey.sortValue] = tureValue;

        totalParams.sort.push(sort);
      }

      // è¿æ»¤
      if (column.filter && column.filter.menus) {
        if (!totalParams.filter) {
          totalParams.filter = [];
        }

        const filter = {};

        filter[column.index] = column.filter.menus.filter(v => v.byDefault).map(v => v.value);

        totalParams.filter.push(filter);
      }
    });

    // sort
    let sortParams = null;
    if (this.isSingleSort && totalParams.sort) {// ååæåº
      sortParams = totalParams.sort[0];
    } else if (!this.isSingleSort) {
      sortParams = {};
      sortParams[this.reqReName.sortWrapKey] = totalParams.sort;
    }

    // filter
    let filterParams = null;
    if (totalParams.filter) {
      filterParams = {};
      filterParams[this.reqReName.filterWrapKey] = totalParams.filter;
    }

    // åå¹¶
    totalParams.merge = Object.assign({}, totalParams.page, totalParams.extra, sortParams, filterParams);

    return totalParams;
  }

  /**
   * å½åé¡µé¢å±ç¤ºæ°æ®æ¹åçåè°å½æ°
   */
  currentPageDataChange(event) {
  }

  /**
   * å¾é/åæ¶å¾éææäºä»¶
   */
  checkAllChange(checked: boolean) {
    const treeData = this.convertTreeToArray(this._data);

    // å¤æ­æ°éæ¯å¦è¶è¿
    if (checked) {
      let unCheckedCount = 0;
      treeData.forEach((item) => {
        // if (!item.checked) {
        //   unCheckedCount += 1;
        // }
        if (!item.checked && !item.disabled) {
          unCheckedCount += 1;
        }
      });
      if (this.maxCheckedCount !== null) {
        if (this.checkedData.length + unCheckedCount > this.maxCheckedCount) {
          this.msgService.error('æå¤§ä¸è¶è¿' + this.maxCheckedCount + 'æ¡æ°æ®');
          return;
        }
      }
    }

    // æ¹åå·²ç¼å­æ°æ®çéä¸­ç¶æ
    treeData.forEach(data => {
      // data.checked = checked;
      if (!data.disabled) {
        data.checked = checked;
      }
      this.changeCheckedData(data, checked);
    });

    // æ´æ°ç¶æ
    const allChecked = treeData.every(v => v.checked === true);
    const allUnChecked = treeData.every(v => !v.checked);
    if (allChecked || allUnChecked) {
      this.allChecked = allChecked;
      this.indeterminate = (!allChecked) && (!allUnChecked);
    }
  }

  /**
   * å¾é/åæ¶å¾éåä¸ªäºä»¶
   */
  checkSingleChange(checked: boolean, data: ADSTData) {
    // å¤æ­æ°éæ¯å¦è¶è¿
    if (this.maxCheckedCount !== null) {
      if (checked && this.checkedData.length + 1 > this.maxCheckedCount) {
        setTimeout(() => {
          data.checked = false;
        });
        this.msgService.error('æå¤§ä¸è¶è¿' + this.maxCheckedCount + 'æ¡æ°æ®');
        return;
      }
    }

    // æ¹åå·²ç¼å­æ°æ®çéä¸­ç¶æ
    this.changeCheckedData(data, checked);

    const treeData = this.convertTreeToArray(this._data);

    const allChecked = treeData.every(value => value.checked === true);
    const allUnChecked = treeData.every(value => !value.checked);
    this.allChecked = allChecked;
    this.indeterminate = (!allChecked) && (!allUnChecked);
  }

  /**
   * å°æ å½¢ç»ææ°ç»è½¬æ¢ææ°ç»
   */
  private convertTreeToArray(treeData: ADSTData[]): ADSTData[] {
    const arr = [];

    // å®ä¹ä¸ä¸ªéå½æ¹æ³
    const deepFn = function (tree: ADSTData[], data: ADSTData[]) {
      for (let i = 0, data_1 = tree; i < data_1.length; i++) {
        const item = data_1[i];

        data.push(item);

        const childrenVal = item.children;
        if (childrenVal && childrenVal.length > 0) {
          deepFn(childrenVal, data);
        }
      }
    };

    deepFn(treeData, arr);

    return arr;
  }

  /**
   * æ¹åå½åä¿å­éä¸­çæ°æ®
   */
  private changeCheckedData(data: ADSTData, checked: boolean) {
    let canAdd = true;

    this.checkedData.forEach((value, index) => {
      if (this.dataKey) {
        if (value[this.dataKey] === data[this.dataKey]) {// æ¾å°ç´¢å¼ç¸åçæ°æ®
          if (!checked) {// åæ¶éä¸­
            this.checkedData.splice(index, 1);
          }
          canAdd = false;
          return;
        }
      }
    });

    // if (canAdd && checked) {
    //   this.checkedData.push(data);
    // }
    if (canAdd && checked && !data.disabled) {
      this.checkedData.push(data);
    }
  }

  /**
   * è¯·æ±æ°æ®
   */
  private requestData(): void {
    const httpParams = this.generateCommonParams().merge;
    let options = {};
    let httpMethod;

    if (this.reqMethod === 'GET') {
      httpMethod = HttpRequestType.GET;
    } else if (this.reqMethod === 'POST') {
      httpMethod = HttpRequestType.POST;
    } else if (this.reqMethod === 'PUT') {
      httpMethod = HttpRequestType.PUT;
    } else if (this.reqMethod === 'DELETE') {
      httpMethod = HttpRequestType.DELETE;
    }

    if (this.reqHeader !== null) {
      options = Object.assign(options, {headers: this.reqHeader});
    } else {// é»è®¤ä½¿ç¨formè¡¨åå½¢å¼
      options = {headers: {'Content-Type': 'application/x-www-form-urlencoded'}};
    }

    this.httpService.request(httpMethod, this.data as string, httpParams, options).subscribe(res => {
      this.loading = false;

      if (res.flag) {
        let httpResponseData = res.data;

        // å¦æéè¦ä»å¤é¢å¤çæ°æ®çæ¶åè°ç¨
        if (this.preResponseDataChange) {
          httpResponseData = this.preResponseDataChange(httpResponseData);
        }

        let dataSource = this.deepGet(httpResponseData, this.resReName.list);
        if (dataSource === null) {
          // æ²¡ææ°æ®çæ¶åï¼æ¾ç¤ºç©ºæ°æ®
          dataSource = [];
          // return;
        }

        if (this.preDataChange) {
          dataSource = this.preDataChange(dataSource);
        }

        this.resetColumnsCache();
        this.processData(dataSource);

        if (!this.isFrontPagination && this.showPagination) {// æ¾ç¤ºåé¡µå¹¶ä¸æ¯åç«¯åé¡µ
          this.total = this.deepGet(httpResponseData, this.resReName.total) || 0;
        }
      }
    });
  }

  /**
   * æåºæ¹åäºä»¶
   */
  sortChange(column: ADSTColumn, value: any) {
    if (this.isSingleSort) {// ååæåº
      // éç½®ä¸ºç©º
      this.columns.forEach(c => {
        if (c.sort && c.sort.sortValue) {
          c.sort.sortValue = null;
        }
      });
    }

    // è®¾ç½®æ°å¼
    column.sort.sortValue = value;

    // æ¬å°æåº
    if (column.sort.compare) {
      this._data = [...this._data.sort(column.sort.compare)];
      return;
    }

    // è¯·æ±æ°æ®
    this.loadData();
  }

  /**
   * å¤åæåºè§¦åäºä»¶
   */
  theadSortChange(sortValue: {key: string, value: 'ascend' | 'descend' | null}) {

  }

  /**
   * è¿æ»¤æ¹å
   */
  filterChange(column: ADSTColumn, filterValues: any[]) {
    if (typeof this.data === 'string') {
      // è¯·æ±æ°æ®
      this.loadData();
    } else {
      // TODO æ¬å°è¿æ»¤ æä¸æ¯æ
    }
  }

  /**
   * æ¯å¦å±å¼
   */
  expandChange(value: boolean) {

  }

  treeExpandChange(value: boolean, data: ADSTData) {
    if (!data.treeExpand || (data.children && data.children.length > 0)) {
      return;
    }
    if (!data.isLeaf) {// ä¸æ¯å¶å­èç¹ï¼å»è¯·æ±æ°æ®
      if (typeof this.data === 'string') {// urlè¯·æ±
        // TODO è¿ç¨è¯·æ± æä¸æ¯æ
      } else {// æ°æ®
        data.isLoading = true;
        this.requestChildrenDataEmitter.emit([data, this.generateCommonParams()]);
      }
    }
  }

  /**
   * æ ¼å¼åthçåå®¹
   */
  formatTheadContent(column: ADSTColumn) {
    // if (column.titleFormat) {
    //   return column.titleFormat(column);
    // }
    if (column.titleFormat) {
      // if (column.formatFromCache && column.titleFormatCache) {
      //   return column.titleFormatCache;
      // }
      // column.titleFormatCache = column.titleFormat(column);
      // return column.titleFormatCache;
      return column.titleFormat(column);
    }
    if (!column.title || column.title === 'null') {
      return '';
    }
    return column.title;
  }

  /**
   * æ ¼å¼åæå­
   */
  formatText(data: ADSTData, column: ADSTColumn, dataIndex: number) {
    // if (column.format) {
    //   return column.format(data);
    // }
    if (column.format) {
      // if (column.formatFromCache && column.formatCache[dataIndex]) {// ä»ç¼å­ä¸­åå¼
      //   return column.formatCache[dataIndex];
      // }
      // column.formatCache[dataIndex] = column.format(data);
      // return column.formatCache[dataIndex];
      return column.format(data);
    }
    if (data[column.index] === 0) {
      return 0;
    }
    if (!data[column.index] || data[column.index] === null || data[column.index] === 'null') {
      return '';
    }
    return data[column.index];
  }

  /**
   * æ ¼å¼åSrc
   */
  formatSrc(data: ADSTData, column: ADSTColumn) {
    if (column.format) {
      return column.format(data);
    }
    return data[column.index];
  }

  /**
   * æ ¼å¼åæé®æ¯å¦æ¾ç¤º
   */
  formatBtnShow(data: ADSTData, btn: ADSTColumnBtn) {
    if (btn.show) {
      return btn.show(data, btn);
    }
    return true;
  }

  /**
   * td className æ ¼å¼å
   */
  tdClassNameFormat(data: ADSTData, column: ADSTColumn) {
    let className = '';
    if (data.tdClassName) {
      className += data.tdClassName + ' ' + column.tdClassName;
    } else {
      className = column.tdClassName;
    }
    return className;
  }

  /**
   * td æ ·å¼ æ ¼å¼å
   */
  tdStylesFormat(data: ADSTData, column: ADSTColumn) {
    let dataTdStyles = {};
    if (data.tdStyles) {
      dataTdStyles = data.tdStyles;
    }
    return {...dataTdStyles, ...column.tdStyles};
  }

  /**
   * è®¡ç®å¯å±å¼çé´è·
   */
  calIndentSize(data: ADSTData, i: number) {
    if (data.level === 0) {
      if (data.isLeaf || !this.asyncTreeData && (!data.children || (data.children && data.children.length === 0))) {
        return null;
      }
      return i === 0 ? data.level * 20 : null;
    }
    return i === 0 ? data.level * 20 : null;
  }

  /**
   * ç¹å»æé®äºä»¶
   */
  btnClick(event, btn: ADSTColumnBtn, data: ADSTData) {
    event.stopPropagation();
    btn.click(data);
  }

  /**
   * è®¡ç®å½ååºåå·
   * @param index å½åé¡µæ°çindex
   */
  calculateOrderNumber(index) {
    if (typeof index === 'string') {
      return '';
    }
    return (this.pageIndex - 1) * (this.pageSize) + index + 1;
  }

  /**
   * å è½½æ°æ®
   */
  public loadData() {
    this.loading = true;

    if (typeof this.data === 'string') {// urlè¯·æ±
      this.requestData();
    } else {// æ°æ®
      this.requestDataEmitter.emit(this.generateCommonParams());
    }
  }

  /**
   * æ¸ç©ºææéæ©çæ°æ®
   */
  public clearChecked() {
    this.checkedData = [];

    this._data.forEach((data) => {
      // è®¾ç½®ç¶æ
      data.checked = false;
    });

    // æ´æ°ç¶æ
    this.allChecked = false;
    this.indeterminate = false;
  }

  /**
   * å é¤éä¸­çæ°æ®
   */
  public deleteCheckedData() {
    // æ¸ç©ºéæ©é¡¹ç®
    this.clearChecked();

    // åå°ç¬¬ä¸é¡µ
    this.pageIndex = 1;
    this.loadData();
  }

  /**
   * è·åææéä¸­çæ°æ®
   */
  public getCheckedData() {
    return this.checkedData;
  }

  /**
   * å é¤å·æ°
   * @param deleteCount å é¤æ°é-é»è®¤æ¯1
   */
  public deleteAndLoadData(deleteCount: number = 1) {
    if (this.showPagination) {
      if (this.isFrontPagination) {// åç«¯åé¡µ

      } else {// åç«¯åé¡µ
        // æ¸ç©ºéæ©é¡¹ç®
        this.clearChecked();

        const curCount = this._data.length;
        if (curCount - deleteCount > 0) {

        } else if (curCount - deleteCount <= 0) {
          // è®¡ç®åºéè¦å é¤çé¡µæ°
          const pageCount = 1 + parseInt(((- (curCount - deleteCount)) / this.pageSize).toString(), 0);

          if (this.pageIndex - pageCount > 0) {
            this.pageIndex = this.pageIndex - pageCount;
          } else {
            this.pageIndex = 1;
          }
        }

        // å·æ°
        this.loadData();
      }
    }
  }
}
